module.exports = __webpack_public_path__ + "static/media/va.27433401.png";